$(function() {
    $(document).on('change', '.js-checkbox', function(){
        $(this).closest('.js-checkbox-label').toggleClass('is-checked');
        $(`.js-checkbox[name="${$(this).prop('name')}"]`)
            .prop('checked', $(this).is(':checked'));
    });

    $('.js-checkbox-all').on('change', function() {
        const target = $(this).data('target');
        const isChecked = $(this).is(':checked');
        const targetList = $('.js-checkbox-list[data-id="' + target + '"] .js-checkbox');

        for (let i = 0; i < targetList.length; i++) {
            $(targetList[i]).prop('checked', isChecked);
        }
    });

    $(document).on('click change', '.js-checkboxes-toggle', function() {
        const wrap = $(this).closest('.js-checkboxes-toggle-wrap');
        const dropdownWrap = $(this).closest('.js-options');
        const target = $(this).data('target');

        if (!$(wrap).hasClass('is-open')) {
            $('.js-checkboxes-toggle-wrap').removeClass('is-open');
            $('.js-checkboxes-toggle-wrap').removeClass('is-open-all');
            $('.js-checkbox-list').removeClass('is-open-all');
            $('.js-checkbox-list').removeClass('is-open');

            $(wrap).addClass('is-open');
            $(dropdownWrap).addClass('is-multicheckboxes');
            $('.js-checkbox-list[data-id="' + target + '"]')
                .addClass('is-open');

            return;
        }

        if ($(window).width() > 767) return;

        $(dropdownWrap).removeClass('is-multicheckboxes');
        $(wrap).removeClass('is-open-all');
        $(wrap).removeClass('is-open');
        $('.js-checkbox-list[data-id="' + target + '"]')
            .removeClass('is-open');
        $('.js-checkbox-list[data-id="' + target + '"]')
            .removeClass('is-open-all');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/checkbox.js